import { useTranslation } from 'react-i18next';

export type PermissionLabels = Record<string, string>;

function usePermissions(): PermissionLabels {
  const { t } = useTranslation();
  return {
    "users.kc_view_user_list": t("permissions.users.kc_view_user_list", "View user list"),
  };
}

export default usePermissions;
